import { render, staticRenderFns } from "./ReceiveAtElevator.vue?vue&type=template&id=67cb4f22&"
import script from "./ReceiveAtElevator.vue?vue&type=script&lang=js&"
export * from "./ReceiveAtElevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports